//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "ReviewApplicantScreening",
    data: function data() {
        return {
            transUnion: {},
            applicant: {},
            modalName: "Review Application",
            isLoading: true,
            loading: false,
            editNotes: false,
            emptyNotes: false,
            audit: {
                user: {
                    full_name: ''
                }
            },
            notesValidation: [{ model: 'transUnion.notes', rules: 'required' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('Review Application', function (item, audit) {
            _this.isLoading = true;
            _this.applicant = item;
            _this.transUnion = item.person.trans_union;
            _this.audit = audit;
            _this.emptyNotes = _this.transUnion.notes ? false : true;
            _this.$initValidator();
            setTimeout(function () {
                _this.isLoading = false;
                var transUnion = document.getElementById("transUnion");
                var transUnionReport = transUnion.contentDocument;
                _this.updateTransunionStyle(transUnionReport);
                _this.showResidentStatusInReview(transUnionReport);
            }, 500);
            Event.$emit('open-slide', _this.modalName);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('Review Application');
    },

    methods: {
        close: function close() {
            Event.$emit('close-slide', this.modalName);
        },
        updateTransunionStyle: function updateTransunionStyle(transUnionReport) {
            transUnionReport.body.innerHTML = transUnionReport.body.innerHTML + '<style>.auto-style11{background: #e2e7ea;}.col1{background: #e2e7ea;} html{background: #e2e7ea;} .screening-status-row{display: flex;flex-flow: row wrap;width: 100%;text-align: center}.status-col{width: 20%}.status-col-header{font-weight: bold;padding-bottom: 5px}</style>';
        },
        showResidentStatusInReview: function showResidentStatusInReview(transUnionReport) {
            transUnionReport.getElementsByClassName('auto-style9')[0].innerHTML += "<span class=\"screening-status-row\">\n                        <div class=\"status-col\">\n                            <div class=\"status-col-header\">Credit</div>\n                            <div>" + this.transUnion.recommendation_message + "</div>\n                        </div>\n                        <div  class=\"status-col\">\n                            <div class=\"status-col-header\">Criminal</div>\n                            <div>" + this.transUnion.criminal_recommendation_message + "</div>\n                        </div>\n                        <div  class=\"status-col\">\n                            <div class=\"status-col-header\">Eviction</div>\n                            <div>" + this.transUnion.eviction_recommendation_message + "</div>\n                        </div>\n                    </span>";
        },
        addNotes: function addNotes() {
            var _this2 = this;

            this.validator.setRules(this.notesValidation).validate();

            if (this.validator.fails()) {
                return;
            }
            this.loading = true;
            axios.post('/prototype/trans-union-add-notes', this.transUnion).then(function (response) {
                _this2.audit = response.data.audit;
                _this2.editNotes = false;
                _this2.loading = false;
                _this2.emptyNotes = false;
                Event.$emit("view-applicant", _this2.applicant);
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ReviewApplicantScreening.vue
// module id = WhLB
// module chunks = 0 1